import { PERMISSIONS_OPTIONS_VALUE } from 'constants/team-members';

const { EDITOR, VIEW_ONLY } = PERMISSIONS_OPTIONS_VALUE;

export const ONLINE_STORE_PERMISSIONS = {
  [VIEW_ONLY]: {
    DIM_ALL_INPUT_FIELDS: true,
    HIDE_PUBLISH_AND_UNPUBLISH: true
  },
  [EDITOR]: {
    HIDE_SETTINGS_TAB: true,
    HIDE_PUBLISH_AND_UNPUBLISH: true
  }
};
